module.exports = "\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/receiving/pda-receiving.component.html
// module id = ../../../../../src/app/agatextscreens/pda/receiving/pda-receiving.component.html
// module chunks = 0